export const ImageMoodToggle = ({ mood, onChange, testIdPrefix }) => {
  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-[#D4AF37]/35 bg-[#FDFBF7]/90 p-1 shadow-[0_10px_30px_rgba(0,25,53,0.08)] backdrop-blur" data-testid={`${testIdPrefix}-toggle`}>
      {[
        { label: "Day", value: "day" },
        { label: "Night", value: "night" },
      ].map((option) => (
        <button
          className={`rounded-full px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] transition ${mood === option.value ? "bg-[#001935] text-white" : "text-[#6b6252] hover:bg-[#001935]/8"}`}
          data-testid={`${testIdPrefix}-${option.value}-button`}
          key={option.value}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};